import { DEFAULT_SORT_BY, DEFAULT_SORT_DIR, FILTER_KEYS } from '../consts';
import { useSearchParams } from 'react-router-dom';
import usePageResettingFilters from 'shared/hooks/usePageResettingFilters';

function useSort() {
  const [searchParams] = useSearchParams();
  // Re-sorting changes which rows fall on page 1, so it resets pagination like any other filter change.
  const { applyFilters } = usePageResettingFilters(FILTER_KEYS.pageNum);

  const sortBy = searchParams.get(FILTER_KEYS.sortBy) ?? DEFAULT_SORT_BY;
  const sortDir = searchParams.get(FILTER_KEYS.sortDir) === 'ASC' ? 'ASC' : DEFAULT_SORT_DIR;

  const toggleSort = (columnKey: string) => {
    applyFilters({
      [FILTER_KEYS.sortBy]: columnKey,
      [FILTER_KEYS.sortDir]: sortBy === columnKey && sortDir === 'DESC' ? 'ASC' : 'DESC',
    });
  };

  return { sortBy, sortDir, toggleSort };
}

export default useSort;
